module.exports = __webpack_public_path__ + "static/media/logo-white.b9c250d4.svg";